import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "nav-overlay-container"
};
const _hoisted_2 = {
  class: "navbar-img-override"
};
const _hoisted_3 = {
  class: "image-slot"
};
const _hoisted_4 = {
  class: "menu-content"
};
const _hoisted_5 = {
  href: "https://shop.autotune.com/",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "nav-tab-header"
};
const _hoisted_6 = {
  class: "nav-tab-content"
};
const _hoisted_7 = {
  class: "nav-tab-content"
};
const _hoisted_8 = {
  class: "nav-tab-content"
};
const _hoisted_9 = {
  class: "nav-tab-content"
};
const _hoisted_10 = {
  href: "https://antaresaudiotechnologies.my.site.com/s/",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "nav-tab-header"
};
const _hoisted_11 = {
  class: "nav-tab-content"
};
const _hoisted_12 = {
  href: "https://antaresaudiotechnologies.my.site.com/s/topic/0TO4V000000oNAZWA2/faqs/",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "nav-tab-header"
};
const _hoisted_13 = {
  class: "nav-tab-content"
};
const _hoisted_14 = {
  class: "nav-tab-content"
};
const _hoisted_15 = {
  class: "nav-tab-content"
};
const _hoisted_16 = {
  class: "nav-tab-content"
};
const _hoisted_17 = {
  class: "nav-tab-content"
};
const _hoisted_18 = {
  class: "nav-tab-content"
};
const _hoisted_19 = {
  class: "nav-tab-content"
};
const _hoisted_20 = {
  class: "nav-overlay-footer"
};
const _hoisted_21 = {
  class: "navbar-options-dropdown"
};
const _hoisted_22 = {
  class: "nav-dropdown-options profile-dropdown"
};
const _hoisted_23 = {
  class: "nav-dropdown-options lang-dropdown"
};
const _hoisted_24 = ["onClick", "onKeydown", "aria-label"];
const _hoisted_25 = ["aria-label"];
import { ref, computed, provide, inject, reactive } from 'vue';
import { useRoute } from 'vue-router';
import { CloseBold, Picture, UserFilled, Right, ArrowRightBold, ShoppingCart, ShoppingCartFull } from '@element-plus/icons-vue';
import Enum from '@/classes/Enum';
import TryFreeBtn from '@/components/TryFreeBtn.vue';
import { useFsLoading } from '@/classes/FastSpring';
import { updateCurrentRoute } from '@/helpers/language';
import NavBarOverlayCollapsible from './NavBarOverlayCollapsible.vue';
import NavBarProductTile from './NavBarProductTile.vue';
import NavMenu from "./NavMenu.json";
import NavBarProductATUBanner from './NavBarProductATUBanner.vue';
import NavBarProductLinksList from './NavBarProductLinksList.vue';
export default {
  __name: 'NavMenuOverlay',
  props: {
    visible: Boolean
  },
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const fsLoading = useFsLoading();
    const user = inject('user');
    const cart = inject('cart');
    const localize = inject('localize');
    const openAuthModal = inject('openAuthModal', () => {});
    const contentContainer = ref(null);
    const SubmenusEnum = new Enum(["UNSET", "UNLIMITED", "AUTOTUNE", "VOCAL_CHAIN", "CREATIVE_EFFECTS", "LEARNING", "SUPPORT"]);
    const props = __props;
    const emit = __emit;
    const openState = computed({
      get: () => {
        return props.visible;
      },
      set: () => {
        handleClose();
      }
    });
    const state = reactive({
      showProfileDropdown: false,
      showLangDropdown: false,
      activeSubmenu: SubmenusEnum.UNSET
    });
    const enabledLangs = localize.getEnabledLangsAsISO();
    const activeLang = computed({
      get() {
        return localize.currCode.value;
      },
      set(value) {
        if (localize.hasLoaded.value) {
          updateCurrentRoute(value);
        }
      }
    });
    const Language = computed(() => {
      return enabledLangs.value?.find(entry => entry.code === activeLang.value) ?? {
        name: "ENG",
        origName: "English",
        code: "en"
      };
    });
    const handleClose = () => {
      emit('close');
      closeDropdowns();
      closeSubmenus();
      if (contentContainer.value) {
        contentContainer.value.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    };
    const handleLang = code => {
      activeLang.value = code;
      closeDropdowns();
    };
    const cartToggle = () => {
      if (!fsLoading.value) {
        cart.toggleVisibility();
        handleClose();
      }
    };
    const handleLogout = () => {
      closeDropdowns();
      user.logout();
    };
    const closeDropdowns = () => {
      state.showProfileDropdown = false;
      state.showLangDropdown = false;
    };
    const toggleDropdown = (dropdown = "") => {
      switch (dropdown) {
        case 'profile':
          state.showProfileDropdown = !state.showProfileDropdown;
          state.showLangDropdown = false;
          break;
        case 'lang':
          state.showLangDropdown = !state.showLangDropdown;
          state.showProfileDropdown = false;
          break;
      }
    };
    const isActiveSubmenu = submenu => {
      return state.activeSubmenu.valueOf() == submenu.valueOf();
    };
    const closeSubmenus = () => {
      state.activeSubmenu = SubmenusEnum.UNSET;
    };
    const toggleSubmenu = submenu => {
      if (state.activeSubmenu.valueOf() === submenu.valueOf()) {
        state.activeSubmenu = SubmenusEnum.UNSET;
      } else {
        state.activeSubmenu = submenu;
      }
    };
    provide('closeNavBar', handleClose);
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_image = _resolveComponent("el-image");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        class: "nav-overlay-dialog",
        modelValue: openState.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => openState.value = $event),
        "show-close": false,
        fullscreen: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
          align: "middle",
          justify: "space-between",
          class: "nav-overlay-header"
        }, {
          default: _withCtx(() => [_createVNode(_component_router_link, {
            to: {
              name: 'Home'
            },
            onClick: handleClose
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_image, {
              alt: "Antares Audio Technologies logo",
              src: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/company-logo/AutoTune_white_logo_with_new_teal_wave.webp",
              style: {
                "height": "100%"
              }
            }, {
              error: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_icon, {
                size: 30
              }, {
                default: _withCtx(() => [_createVNode(_unref(Picture))]),
                _: 1
              })])]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_button, {
            circle: "",
            class: "gray-base",
            onClick: handleClose,
            "data-testid": "navMenuButton",
            icon: _unref(CloseBold),
            size: "large"
          }, null, 8, ["icon"])]),
          _: 1
        }), _createElementVNode("div", {
          class: "nav-overlay-content",
          ref_key: "contentContainer",
          ref: contentContainer
        }, [_createVNode(NavBarOverlayCollapsible, {
          visible: isActiveSubmenu(_unref(SubmenusEnum).UNLIMITED),
          onOpen: _cache[0] || (_cache[0] = () => toggleSubmenu(_unref(SubmenusEnum).UNLIMITED)),
          onClose: _cache[1] || (_cache[1] = $event => closeSubmenus())
        }, {
          content: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(NavBarProductATUBanner, {
            class: "menu-content-section"
          })])]),
          default: _withCtx(() => [_createVNode(NavBarProductTile, {
            isActive: isActiveSubmenu(_unref(SubmenusEnum).UNLIMITED),
            image: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/navigation/autotune_unlimited_logo.webp",
            style: {
              "padding": "0"
            },
            name: "AutoTune Unlimited",
            description: "Subscription with all 23 plugins and free upgrades"
          }, null, 8, ["isActive"])]),
          _: 1
        }, 8, ["visible"]), _createVNode(NavBarOverlayCollapsible, {
          visible: isActiveSubmenu(_unref(SubmenusEnum).AUTOTUNE),
          onOpen: _cache[2] || (_cache[2] = () => toggleSubmenu(_unref(SubmenusEnum).AUTOTUNE)),
          onClose: _cache[3] || (_cache[3] = $event => closeSubmenus())
        }, {
          content: _withCtx(() => [_createVNode(NavBarProductLinksList, {
            items: _unref(NavMenu).ATEditions
          }, null, 8, ["items"])]),
          default: _withCtx(() => [_createVNode(NavBarProductTile, {
            isActive: isActiveSubmenu(_unref(SubmenusEnum).AUTOTUNE),
            image: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/navigation/autotune_editions_logo.webp",
            style: {
              "padding": "0"
            },
            name: "AutoTune Editions",
            description: "Professional pitch correction plugins"
          }, null, 8, ["isActive"])]),
          _: 1
        }, 8, ["visible"]), _createVNode(NavBarOverlayCollapsible, {
          visible: isActiveSubmenu(_unref(SubmenusEnum).VOCAL_CHAIN),
          onOpen: _cache[4] || (_cache[4] = () => toggleSubmenu(_unref(SubmenusEnum).VOCAL_CHAIN)),
          onClose: _cache[5] || (_cache[5] = $event => closeSubmenus())
        }, {
          content: _withCtx(() => [_createVNode(NavBarProductLinksList, {
            items: _unref(NavMenu).VocalChain
          }, null, 8, ["items"])]),
          default: _withCtx(() => [_createVNode(NavBarProductTile, {
            isActive: isActiveSubmenu(_unref(SubmenusEnum).VOCAL_CHAIN),
            image: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/navigation/ai_vocal_chain_logo.webp",
            style: {
              "padding": "0"
            },
            name: "AI Vocal Chain",
            description: "Your intelligent vocal mixing assistant"
          }, null, 8, ["isActive"])]),
          _: 1
        }, 8, ["visible"]), _createVNode(NavBarOverlayCollapsible, {
          visible: isActiveSubmenu(_unref(SubmenusEnum).CREATIVE_EFFECTS),
          onOpen: _cache[6] || (_cache[6] = () => toggleSubmenu(_unref(SubmenusEnum).CREATIVE_EFFECTS)),
          onClose: _cache[7] || (_cache[7] = $event => closeSubmenus())
        }, {
          content: _withCtx(() => [_createVNode(NavBarProductLinksList, {
            items: _unref(NavMenu).CreativeEffects
          }, null, 8, ["items"])]),
          default: _withCtx(() => [_createVNode(NavBarProductTile, {
            isActive: isActiveSubmenu(_unref(SubmenusEnum).CREATIVE_EFFECTS),
            image: "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/navigation/creative_effects_logo.webp",
            style: {
              "padding": "0"
            },
            name: "Creative Effects",
            description: "Voice modifiers, multi-effects, and more"
          }, null, 8, ["isActive"])]),
          _: 1
        }, 8, ["visible"]), _createElementVNode("a", _hoisted_5, [_createElementVNode("h3", _hoisted_6, [_cache[19] || (_cache[19] = _createElementVNode("span", null, "Merch", -1)), _createVNode(_unref(Right), {
          class: "el-icon"
        })])]), _createVNode(NavBarOverlayCollapsible, {
          visible: isActiveSubmenu(_unref(SubmenusEnum).LEARNING),
          onOpen: _cache[8] || (_cache[8] = () => toggleSubmenu(_unref(SubmenusEnum).LEARNING)),
          onClose: _cache[9] || (_cache[9] = $event => closeSubmenus())
        }, {
          content: _withCtx(() => [_createVNode(_component_router_link, {
            to: {
              name: 'Community'
            },
            class: "nav-tab-header"
          }, {
            default: _withCtx(() => [_createElementVNode("h4", _hoisted_7, [_cache[20] || (_cache[20] = _createElementVNode("span", null, "Blog", -1)), _createVNode(_unref(Right), {
              class: "el-icon"
            })])]),
            _: 1
          }), _createVNode(_component_router_link, {
            to: {
              name: 'LearningCenter'
            },
            class: "nav-tab-header"
          }, {
            default: _withCtx(() => [_createElementVNode("h4", _hoisted_8, [_cache[21] || (_cache[21] = _createElementVNode("span", null, "Tutorials", -1)), _createVNode(_unref(Right), {
              class: "el-icon"
            })])]),
            _: 1
          }), _createVNode(_component_router_link, {
            to: {
              name: 'Artists'
            },
            class: "nav-tab-header"
          }, {
            default: _withCtx(() => [_createElementVNode("h4", _hoisted_9, [_cache[22] || (_cache[22] = _createElementVNode("span", null, "Artists", -1)), _createVNode(_unref(Right), {
              class: "el-icon"
            })])]),
            _: 1
          })]),
          default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("h3", {
            style: {
              "font-size": "inherit"
            }
          }, "Learning", -1))]),
          _: 1
        }, 8, ["visible"]), _createVNode(NavBarOverlayCollapsible, {
          visible: isActiveSubmenu(_unref(SubmenusEnum).SUPPORT),
          onOpen: _cache[10] || (_cache[10] = () => toggleSubmenu(_unref(SubmenusEnum).SUPPORT)),
          onClose: _cache[11] || (_cache[11] = $event => closeSubmenus())
        }, {
          content: _withCtx(() => [_createElementVNode("a", _hoisted_10, [_createElementVNode("h4", _hoisted_11, [_cache[24] || (_cache[24] = _createElementVNode("span", null, "Customer Service", -1)), _createVNode(_unref(Right), {
            class: "el-icon"
          })])]), _createElementVNode("a", _hoisted_12, [_createElementVNode("h4", _hoisted_13, [_cache[25] || (_cache[25] = _createElementVNode("span", null, "FAQ", -1)), _createVNode(_unref(Right), {
            class: "el-icon"
          })])]), _createVNode(_component_router_link, {
            to: {
              name: 'WPPageRenderer',
              params: {
                slug: 'getting-started'
              }
            },
            class: "nav-tab-header"
          }, {
            default: _withCtx(() => [_createElementVNode("h4", _hoisted_14, [_cache[26] || (_cache[26] = _createElementVNode("span", null, "Getting Started", -1)), _createVNode(_unref(Right), {
              class: "el-icon"
            })])]),
            _: 1
          }), _createVNode(_component_router_link, {
            to: {
              name: 'SoftwareDownload'
            },
            class: "nav-tab-header"
          }, {
            default: _withCtx(() => [_createElementVNode("h4", _hoisted_15, [_cache[27] || (_cache[27] = _createElementVNode("span", null, "Download Manager", -1)), _createVNode(_unref(Right), {
              class: "el-icon"
            })])]),
            _: 1
          }), _createVNode(_component_router_link, {
            to: {
              name: 'DiscontinuedSoftwareDownload'
            },
            class: "nav-tab-header"
          }, {
            default: _withCtx(() => [_createElementVNode("h4", _hoisted_16, [_cache[28] || (_cache[28] = _createElementVNode("span", null, "Legacy Installers", -1)), _createVNode(_unref(Right), {
              class: "el-icon"
            })])]),
            _: 1
          }), _createVNode(_component_router_link, {
            to: {
              name: 'Documentation'
            },
            class: "nav-tab-header"
          }, {
            default: _withCtx(() => [_createElementVNode("h4", _hoisted_17, [_cache[29] || (_cache[29] = _createElementVNode("span", null, "Product Manuals", -1)), _createVNode(_unref(Right), {
              class: "el-icon"
            })])]),
            _: 1
          }), _createVNode(_component_router_link, {
            to: {
              name: 'WPPageRenderer',
              params: {
                slug: 'daw-compatibility'
              }
            },
            class: "nav-tab-header"
          }, {
            default: _withCtx(() => [_createElementVNode("h4", _hoisted_18, [_cache[30] || (_cache[30] = _createElementVNode("span", null, "DAW Compatibility", -1)), _createVNode(_unref(Right), {
              class: "el-icon"
            })])]),
            _: 1
          })]),
          default: _withCtx(() => [_cache[31] || (_cache[31] = _createElementVNode("h3", {
            style: {
              "font-size": "inherit"
            }
          }, "Support", -1))]),
          _: 1
        }, 8, ["visible"]), _createVNode(_component_router_link, {
          to: {
            name: 'WPPageRenderer',
            params: {
              slug: 'auto-tune-special-offers'
            }
          },
          onClick: handleClose,
          class: "nav-tab-header"
        }, {
          default: _withCtx(() => [_createElementVNode("h3", _hoisted_19, [_cache[32] || (_cache[32] = _createElementVNode("span", null, "Special Offers", -1)), _createVNode(_unref(Right), {
            class: "el-icon"
          })])]),
          _: 1
        })], 512), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_withDirectives(_createElementVNode("div", _hoisted_22, [_createVNode(_component_router_link, {
          to: {
            name: 'Overview'
          },
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[33] || (_cache[33] = [_createElementVNode("div", {
            class: "nav-dropdown-option"
          }, " My Account ", -1)])),
          _: 1
        }), _createVNode(_component_router_link, {
          to: {
            name: 'Profile'
          },
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[34] || (_cache[34] = [_createElementVNode("div", {
            class: "nav-dropdown-option"
          }, " Account Settings ", -1)])),
          _: 1
        }), _createVNode(_component_router_link, {
          to: {
            name: 'Orders'
          },
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [_createElementVNode("div", {
            class: "nav-dropdown-option"
          }, " Order History ", -1)])),
          _: 1
        }), _unref(user).hasAvailableUpgrades ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: {
            name: 'UserUpgrades'
          },
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createVNode(_component_el_badge, {
            type: "primary",
            value: _unref(user).summary.available_upgrades,
            class: "upgrades-badge"
          }, {
            default: _withCtx(() => _cache[36] || (_cache[36] = [_createElementVNode("div", {
              class: "nav-dropdown-option"
            }, " Available Offers ", -1)])),
            _: 1
          }, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "nav-dropdown-option",
          onClick: handleLogout,
          onKeydown: _withKeys(handleLogout, ["enter"]),
          tabindex: "0",
          role: "button"
        }, " Logout ", 32)], 512), [[_vShow, state.showProfileDropdown && !_unref(user).state.logoutLoading]]), _withDirectives(_createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(enabledLangs).filter(lang => lang.code !== activeLang.value), lang => {
          return _openBlock(), _createElementBlock("div", {
            key: lang.code,
            class: "nav-dropdown-option",
            notranslate: "",
            onClick: () => handleLang(lang.code),
            onKeydown: _withKeys(() => handleLang(lang.code), ["enter"]),
            role: "button",
            tabindex: "0",
            "aria-label": lang.origName
          }, _toDisplayString(lang.name), 41, _hoisted_24);
        }), 128))], 512), [[_vShow, state.showLangDropdown]])]), _createVNode(_component_el_row, {
          align: "middle",
          justify: "space-between",
          class: "navbar-options"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            align: "middle",
            justify: "space-between",
            style: {
              "gap": "8px"
            }
          }, {
            default: _withCtx(() => [_unref(route).name !== 'Checkout' ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[12] || (_cache[12] = () => cartToggle()),
              style: _normalizeStyle({
                cursor: _unref(fsLoading) ? 'default' : 'pointer'
              }),
              "data-testid": "showCartButton"
            }, [_unref(cart).totalItems && typeof _unref(cart).totalItems === 'number' && _unref(cart).totalItems > 0 ? (_openBlock(), _createBlock(_component_el_badge, {
              key: 0,
              type: "primary",
              value: _unref(cart).totalItems
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                disabled: _unref(fsLoading),
                loading: _unref(fsLoading),
                class: "gray-base",
                size: "large",
                type: "primary",
                plain: "",
                icon: _unref(ShoppingCartFull),
                circle: ""
              }, null, 8, ["disabled", "loading", "icon"])]),
              _: 1
            }, 8, ["value"])) : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              disabled: _unref(fsLoading),
              loading: _unref(fsLoading),
              class: "gray-base",
              size: "large",
              type: "primary",
              plain: "",
              icon: _unref(ShoppingCart),
              circle: ""
            }, null, 8, ["disabled", "loading", "icon"]))], 4)) : _createCommentVNode("", true), _unref(user) && _unref(user).id ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_unref(user).hasAvailableUpgrades ? (_openBlock(), _createBlock(_component_el_badge, {
              key: 0,
              type: "primary",
              "is-dot": "",
              offset: [-5, 5]
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                class: "gray-base",
                size: "large",
                type: "primary",
                plain: "",
                icon: _unref(UserFilled),
                circle: "",
                disabled: _unref(user).state.logoutLoading,
                loading: _unref(user).state.logoutLoading,
                "data-testid": "userDropdownButton",
                onClick: _cache[13] || (_cache[13] = () => toggleDropdown('profile'))
              }, null, 8, ["icon", "disabled", "loading"])]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "gray-base",
              size: "large",
              type: "primary",
              plain: "",
              icon: _unref(UserFilled),
              circle: "",
              disabled: _unref(user).state.logoutLoading,
              loading: _unref(user).state.logoutLoading,
              "data-testid": "userDropdownButton",
              onClick: _cache[14] || (_cache[14] = () => toggleDropdown('profile'))
            }, null, 8, ["icon", "disabled", "loading"]))], 64)) : (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              size: "large",
              plain: "",
              class: "gray-base",
              onClick: _cache[15] || (_cache[15] = () => _unref(openAuthModal)()),
              "data-testid": "signInButton"
            }, {
              default: _withCtx(() => _cache[37] || (_cache[37] = [_createTextVNode(" Sign In ")])),
              _: 1
            }))]),
            _: 1
          }), _createElementVNode("div", {
            class: _normalizeClass(["nav-overlay-lang", {
              'dropdown-active': state.showLangDropdown
            }]),
            onClick: _cache[16] || (_cache[16] = () => toggleDropdown('lang')),
            onKeydown: _cache[17] || (_cache[17] = _withKeys(() => toggleDropdown('lang'), ["enter"])),
            role: "button",
            tabindex: "0",
            "aria-label": Language.value.origName,
            notranslate: ""
          }, [_createTextVNode(_toDisplayString(Language.value.name) + " ", 1), _createVNode(_unref(ArrowRightBold), {
            class: "el-icon"
          })], 42, _hoisted_25)]),
          _: 1
        }), !(_unref(user).isSubscriber || _unref(user).isTrialer) ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          align: "middle",
          justify: "center",
          style: {
            "padding": "4px 24px 16px"
          }
        }, {
          default: _withCtx(() => [_createVNode(TryFreeBtn, {
            style: {
              "width": "100%"
            }
          })]),
          _: 1
        })) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};